'use client'

import React, { useEffect, useState } from 'react'

// Desktop Layout Template (Uses key: f258118b8366afbce7141ef04238b9ef)
const nativeDesktopHTML = `
    <!DOCTYPE html>
    <html>
    <head>
    <style>
        body { margin: 0; padding: 0; overflow: hidden; display: flex; justify-content: center; align-items: center; }
    </style>
    </head>
    <body>
    <div id="container-f258118b8366afbce7141ef04238b9ef"></div>
    <` + `script async="true" data-cfasync="false" src="https://pl29535363.effectivecpmnetwork.com/f258118b8366afbce7141ef04238b9ef/invoke.js"></` + `script>
    </body>
    </html>
`;

// Mobile Layout Template (Uses key: 6838f7bce5c18cc823d36bb234236391)
const nativeMobileHTML = `
    <!DOCTYPE html>
    <html>
    <head>
    <style>
        body { margin: 0; padding: 0; overflow: hidden; display: flex; justify-content: center; align-items: center; }
    </style>
    </head>
    <body>
    <div id="container-6838f7bce5c18cc823d36bb234236391"></div>
    <` + `script async="true" data-cfasync="false" src="https://pl29536543.effectivecpmnetwork.com/6838f7bce5c18cc823d36bb234236391/invoke.js"></` + `script>
    </body>
    </html>
`;

function AdSterraNativeBanner() {
    useEffect(() => {
        const handleResolutionAndInject = () => {
            const isDesktopLayout = window.innerWidth >= 768;

            if (isDesktopLayout) {
                const desktopContainer = document.getElementById('native-desktop-slot');
                
                if (desktopContainer && desktopContainer.childElementCount === 0) {
                    const iframe = document.createElement('iframe');
                    iframe.srcdoc = nativeDesktopHTML;
                    iframe.width = '100%';
                    // Adjust height to match whatever your Adsterra native banner widget height requirement is (e.g., 250 or 400)
                    iframe.style.minHeight = '250px'; 
                    iframe.style.border = 'none';
                    iframe.style.overflow = 'auto';
                    iframe.scrolling = 'no';
                    
                    desktopContainer.appendChild(iframe);
                }
            } else {
                const mobileContainer = document.getElementById('native-mobile-slot');
                
                if (mobileContainer && mobileContainer.childElementCount === 0) {
                    const iframe = document.createElement('iframe');
                    iframe.srcdoc = nativeMobileHTML;
                    iframe.width = '100%';
                    iframe.style.minHeight = '250px'; 
                    iframe.style.border = 'none';
                    iframe.style.overflow = 'auto';
                    iframe.scrolling = 'no';
                    
                    mobileContainer.appendChild(iframe);
                }
            }
        };

        // Execute immediately on the client browser safely
        handleResolutionAndInject();

        window.addEventListener('resize', handleResolutionAndInject);
        return () => {
            window.removeEventListener('resize', handleResolutionAndInject);
        };
    }, []);
  
    return (
        <div className='w-full flex justify-center items-center mt-4 mb-4'>
            {/* The HTML wrappers match on server and client, completely preventing hydration crashes */}
            <div id="native-desktop-slot" className="hidden w-full md:flex justify-center items-center" style={{ minHeight: '100px', overflow: 'auto' }} />
            <div id="native-mobile-slot" className="block md:hidden w-full flex justify-center items-center" style={{ minHeight: '100px', overflow: 'auto' }} />
        </div>
    )
}

export default AdSterraNativeBanner;